import createAppSlice from 'app/createAppSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import { IOffer, IGroup, IOfferGroupType, IScheduledOffer } from './types';

const initialState: IOfferGroupType = {
  code: '',
  planCode: '',
  planName: '',
  prefixCode: '',
  brandCode: '',
  companyCode: '',
  customerBilled: false,
  customerPrice: 0,
  serviceEndDate: null,
  servicePeriod: null,
  billingType: null,
  createdAt: null,
  defaultConversionOfferCode: null,
  defaultOffer: false,
  description: null,
  discountAmount: null,
  endDate: null,
  hasFreeTrial: false,
  hasPaidTrial: false,
  hasTrial: false,
  id: '',
  isInboundTM: false,
  offerGroup: null,
  offerType: '',
  price: 0,
  retailPrice: 0,
  startDate: null,
  subscriptionPlanCode: null,
  trialDuration: 0,
  trialPrice: 0,
  updatedAt: '',
  isUserInTrial: null,
  subscriptionPlan: {
    code: '',
    termDescription: '',
    termLength: 0,
    termName: '',
  },
  group: {
    code: '',
    name: '',
    type: '',
  },
  scheduledOffer: null,
  planFamily: false,
  planTier: null,
  planFeatures: [],
};

const OfferSlice = createAppSlice({
  name: 'offer',
  initialState,
  reducers: {
    setOffer: (state, action: PayloadAction<IOffer>) => {
      return { ...state, ...action.payload };
    },
    setGroup: (state, action: PayloadAction<IGroup>) => {
      state.group = action.payload;
    },
    setScheduledOffer: (state, action: PayloadAction<IScheduledOffer>) => {
      state.scheduledOffer = action.payload;
    },
    resetOfferSlice: () => {
      return initialState;
    },
  },
});

export const { setOffer, setGroup, setScheduledOffer, resetOfferSlice } =
  OfferSlice.actions;
export default OfferSlice.reducer;
